<template>
	<b-row>
		<b-col md v-if="viewModel.id > 0">
			<small v-if="$hasPermission('reservation.createdInfo')">
				<strong>Reserva creada por:</strong>
				{{ viewModel.creationUser.firstName }} |
				{{ reservationDatetimeStr }}
				<template v-if="viewModel.cancelUser">
					<br />
					<strong>Cancelado por:</strong>
					{{ viewModel.cancelUser.firstName }} /
					<strong>Fecha cancelación: </strong>
					<date-label :date="viewModel.cancelDatetime"></date-label>
				</template>
			</small>
			<small v-else>
				<strong>Reserva creada:</strong>
				{{ reservationDatetimeStr }}
			</small>
		</b-col>
		<b-col md class="text-right" >
			<b-button
				class="mr-2 btn-sm"
				variant="success"
				@click="openFormQuote"
				v-if="$hasPermission('reservation.quote')"
				><md-icon icon="request_quote"></md-icon> Cotizar
			</b-button>

			<b-button
				v-if="viewModel.id > 0 && $hasPermission('reservation.copy')"
				@click="$emit('onCopyRes')"
				variant="dark"
				class="mr-2"
				size="sm"
				><md-icon icon="library_add" /> Copiar reserva</b-button
			>
			<b-button
				v-if="isCancelable && viewModel.id > 0 && $hasPermission('reservation.booking.cancel')"
				@click="$bvModal.show('cancel-reservation-modal')"
				variant="danger"
				size="sm"
				><md-icon icon="delete" /> Cancelar reserva</b-button
			>
		</b-col>
		<b-modal
			id="cancel-reservation-modal"
			size="sm"
			body-class="position-static"
			hide-header
			centered
		>
			La reserva sera <strong>cancelada</strong> y no sera posible
			reactivarla
			<hr />
			<b-form-group label="Registra una nota">
				<b-textarea v-model="cancelResNote" />
			</b-form-group>



      <template #modal-footer="{ close }">
        <b-button
          :disabled="cancelResLoading"
          @click="close()"
          type="button"
          class="float-right"
        >
          Cerrar
        </b-button>
        <b-button
          :disabled="cancelResLoading"
          @click="doCancel"
          type="button"
          variant="danger"
          class="float-right"
        >
          <span v-if="!cancelResLoading">Cancelar Reserva</span>
          <span v-else><b-spinner small></b-spinner> Procesando...</span>
        </b-button>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import moment from "moment";
import { mapActions, mapState, mapMutations } from "vuex";
import api from "@/api.js";
import DateLabel from '../../../../helpers/DateLabel.vue';

export default {
    components: { DateLabel },
	props: {
		modelId: Number,
		copyFromId: Number,
		isCancelable: Boolean
	},
	data: () => ({
		cancelResLoading: false,
		cancelResNote: ""
	}),
	computed: {
		...mapState("reservation", ["viewModel", "quote"]),
		reservationDatetimeStr() {
			return moment(this.viewModel.reservationDatetime).format(
				"DD/MMMM/YYYY HH:mm:ss"
			);
		}
	},
	methods: {
		...mapActions("reservation", ["_fetchModel", "_fetchNotes"]),
		...mapMutations("reservation", ["SET_UPDATE_QUOTE_PROPS", "SET_RESET_MODEL","DEL_TRANSPORT_SERVICE"]),
		doCancel() {
			this.cancelResLoading = true;
			api(this)
				.post(`/reservations/cancel/${this.viewModel.id}`, {
					note: this.cancelResNote
				})
				.then(() => {
					this.$root.showAlert("Reserva cancelada con éxito");
					this.cancelResLoading = false;
					this.cancelResNote = "";
					const params = {
						context: this,
						modelId: this.modelId,
						copyFromId: this.copyFromId
					};
					this._fetchModel(params);
					this._fetchNotes(params);

          this.$bvModal.hide("cancel-reservation-modal");

          this.$root.$emit("bv::refresh::table", "reservations-index-list");
        })
        .catch(this.$root.handleRequestError)
		.finally(()=>{
			this.cancelResLoading = false;
		})
    },
    openFormQuote() {
		// this.SET_UPDATE_QUOTE_PROPS({ showForm: true });
		if(this.viewModel.id == -1){
			let existCartTransport=this.viewModel.transportServices.find(item=>{return ("cartId" in item)});
			if(existCartTransport){
				console.log("New Quote: don't change view model");
			}else{
				console.log("New Quote: reset view model");
				//reseteamos el viewModel para crear uno nuevo
				// this.SET_RESET_MODEL();
				// eliminaos todos los transport service
				// this.DEL_TRANSPORT_SERVICE(0);
			}
		}

		// let existCartAdditional=this.viewModel.additionalServices.find(item=>{return item.id==-1});
			// let existCartTransport=this.viewModel.transportServices.find(item=>{return ("cartId" in item)});
			// if(existCartTransport && this.viewModel.id == -1){
			// 	console.log("New Quote: view model");
			// }else{
			// 	console.log("New Quote: reset view model");
			// 	//reseteamos el viewModel para crear uno nuevo
			// 	this.SET_RESET_MODEL();
			// 	// eliminaos todos los transport service
			// 	this.DEL_TRANSPORT_SERVICE(0);
			// }
			// this.SET_UPDATE_QUOTE_PROPS({showForm:true})//?? en que momento se recupera la infrmacion consultada en el modal de cotizacion

		this.SET_UPDATE_QUOTE_PROPS({showForm:true})//?? en que momento se recupera la infrmacion consultada en el modal de cotizacion

    },
  },
};
</script>

<style></style>
